import { TableColumnModel } from '../../Models/TableColumnModel';
import InputContentChip from './InputContentChip';

type TableColumnsInputContentProps = {
	value: TableColumnModel[] | undefined;
};

export default function TableColumnsInputContent({ value }: TableColumnsInputContentProps) {
	if (!value || value.length === 0) {
		return null;
	}

	const label = value.length === 1 ? '1 column' : `${value.length} columns`;

	return <InputContentChip label={label} />;
}
